import * as React from "react";
import FormComponentInner from './formComponentInner';
import shortid from 'shortid';
import {
    GoogleReCaptchaProvider,
    withGoogleReCaptcha
} from 'react-google-recaptcha-v3';

//const WithGoogleRecaptchaForm = withGoogleReCaptcha(FormComponentInner);
class FormComponent extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            captchaElementId: 'captcha_' + shortid.generate()
        };
    }

    render() {

        return (<FormComponentInner {...this.props} />);


        //return (<GoogleReCaptchaProvider reCaptchaKey={this.props.gooleRecaptchaSitekey} container={{
        //    //element: this.state.captchaElementId,
        //    parameters: {
        //        badge: 'bottomright'
        //    }
        //}}>
        //    <WithGoogleRecaptchaForm {...this.props} />            
        //</GoogleReCaptchaProvider>)
    }
}

export default FormComponent;